import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyMediaApiService } from './company-media-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyMediaApiService extends GeneratedCompanyMediaApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
